export default {
  items: state => state.items,
  item: state => id => state.items.find(item => item.id === id),
  sort: state => state.sort,
  more: state => state.more,
  loading: state => state.loading,
  logs: state => state.logs,
  logsItems: state => state.logs.items,
  logsLimit: state => state.logs.limit,
  logsLoading: state => state.logs.loading,
  logsPage: state => state.logs.page,
  logsTotal: state => state.logs.total,
  total: state => state.total,
  pendingProgressUpdate: state => state.pendingProgressUpdate,
  isPendingProgressUpdate: state => item => state.pendingProgressUpdate.indexOf(item) !== -1,
  defaultSort: state => state.defaultSort,
};
